const MOBILE_NET_MODE = {
    0x00: "AUTO",
    0x01: "4G_FIRST",
    0x02: "4G_ONLY",
    0x03: "3G_FIRST",
    0x04: "3G_ONLY",
    0x05: "2G_FIRST",
    0x06: "2G_ONLY"
};

const REG_TYPE = {
    0x00: 'COIL',
    0x01: 'DISCRETE',
    0x02: 'INPUT',
    0x03: 'HOLD_INT16',
    0x04: 'HOLD_INT32',
    0x05: 'HOLD_FLOAT',
};

module.exports.MOBILE_NET_MODE = MOBILE_NET_MODE;
module.exports.REG_TYPE = REG_TYPE;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/constant.js